import { ControllerBase } from "controllerBase";
import global from 'globalMU'

declare var window:any

const _ = require('underscore')

const EditarParcelaController = ControllerBase.extend({
    name: "EditarParcelaController",

    framework: "knockout",

    ajax: function () {

        
    },

    newModel: function () {

        
    },

    antesBinding: function () {

        
    },

    aposBinding: function () {
        
    },

    

    salvar: function (model, e) {

        
    },

    decodificarCMC7: function () {

        

    },

    gerarListaParcelaCartao: function () {
        this.model.ListaQuantidadeParcelas.removeAll();
        this.model.QuantidadeParcelasCartao(undefined);
        if (!this.model.IdTipoDocumento()) {
            return;
        }

        var tipos = this.toJS(this.model.tiposDocumentoGeral());
        var tipoDocumento = global.where(tipos, { Codigo: this.model.IdTipoDocumento() });
        if (tipoDocumento == undefined || tipoDocumento.length == 0) {
            return;
        }
        if (tipoDocumento[0].Tipo != 17763 && tipoDocumento[0].Tipo != 16200) {
            return;
        }
        if (this.model.Tipo() == 2) {
            if (this.model.QuantidadeParcelasCartaoOriginal() > 0)
                this.model.ListaQuantidadeParcelas.push({ QuantidadeParcela: this.model.QuantidadeParcelasCartaoOriginal() });
            else
                this.model.ListaQuantidadeParcelas.push({ QuantidadeParcela: tipoDocumento[0].QuantidadeMinimaParcelaPrazo });
            return;
        }

        if (tipoDocumento[0].QuantidadeMinimaParcelaVista == 0)
            tipoDocumento[0].QuantidadeMinimaParcelaVista = 1

        for (var i = tipoDocumento[0].QuantidadeMinimaParcelaVista; i <= tipoDocumento[0].QuantidadeMaximaParcelaVista; i++) {
            this.model.ListaQuantidadeParcelas.push({ QuantidadeParcela: i });
        }
        this.model.QuantidadeParcelasCartao(this.model.QuantidadeParcelasCartaoOriginal())
        this.calcularValorParcelaCartao();
    },

    calcularValorParcelaCartao: function () {
        
    }

});

window.EditarParcelaController = EditarParcelaController

export {
    EditarParcelaController
}